import React from 'react';
import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="cta-section">
      <div className="wrap">
        <div className="cta-box rv">
          <h2>Need a backend or AI<br />automation partner?</h2>
          <p>
            Let's discuss your project and find the fastest path to production.
            No sales pitch — just engineering clarity in 30 minutes.
          </p>
          <div className="cta-actions">
            <Link to="/contact" className="btn-p">Book a Free Consultation →</Link>
            <Link to="/case-studies" className="btn-g">View Our Work</Link>
          </div>
          <p className="cta-note">
            Also available on Upwork · Fiverr · Direct contracts · Respond within 24 hours
          </p>
        </div>
      </div>
    </section>
  );
}
